module.exports = __webpack_public_path__ + "static/media/close.f21bbd0d.svg";